import React, {Component} from 'react';
import {withRouter} from "react-router-dom";

import SearchBar from '../../components/Search/Search';
import SearchBarFooter from '../../components/Search/SearchBarFooter';
import MenuItemCell from '../../components/Search/MenuItemCell';
import { getAssetsMatching } from '../../Api';

class Search extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            isLoading: false
        };
    }

    render() {
        return (
            <div>
                 <SearchBar
                    isDark={this.props.dark}
                    isLoading={this.state.isLoading}
                    items={this.state.items}
                    labelrenderer="title"
                    placeholder="Search for a product"
                    menuItemCell={MenuItemCell}
                    menuItemFooter={SearchBarFooter}
                    inputChange={this.loadSuggestions}
                    itemSelected={this.searchItemSelected}
                    footerViewAllClicked={this.seeAllProductsSelected}
                    onSearch={this.seeAllProductsSelected}
                 />
            </div>
        );
    }

    search = (value) => {
        this.props.history.push(`/browse?searchTerm=${value}`);
    }

    searchItemSelected = (item) => {
        if (item) {
            this.setState({items: []});
            this.props.history.push(`/asset/${item.technopedia_id}`);
        }
    }

    seeAllProductsSelected = (term) => {
        this.setState({items: []});
        this.props.history.push(`/browse?searchTerm=${term}`);
    }

    loadSuggestions = (input) => {
        this.setState({isLoading: true});
        getAssetsMatching(input).then((response) => {
          this.setState({items: response.data.results, isLoading: false});
        })
      }
}

export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/containers/Search/Search.js